<div class="navigation">
  <div class="navigation__section">
    <button
      tuiButton
      type="button"
      size="s"
      (click)="saveColumns()"
    >
      Apply
    </button>

    <button
      class="save-as-default"
      tuiButton
      type="button"
      size="s"
      (click)="saveAsDefault()"
    >
      Apply and save as default
    </button>
  </div>

  <div class="navigation__section">
    <button
      class="save-as-default"
      tuiButton
      type="button"
      size="s"
      appearance="flat"
      [disabled]="showFoundSettings"
      (click)="selectAll()"
    >
      Select all
    </button>

  <button
    class="save-as-default"
    tuiButton
    type="button"
    size="s"
    appearance="flat"
    [disabled]="showFoundSettings"
    (click)="unselectAll()"
  >
    Unselect all
  </button>
  </div>
</div>
<form class="search-setting default-textfield b-form">
  <tui-input
    [(ngModel)]="searchValue"
    (ngModelChange)="searchSettings($event)"
    [ngModelOptions]="{standalone: true}"
    [tuiTextfieldCleaner]="true"
  >
    Search
    <input
        type="text"
        tuiTextfield
    />
  </tui-input>
<br />
</form>

<tui-tree
  *ngFor="let item of data.children"
  [ngStyle]="{display: showFoundSettings ? 'none' : 'block'}"
  [tuiTreeController]="false"
  [value]="item"
  [content]="content"
  [map]="toggleMap"
  [childrenHandler]="handler"
></tui-tree>


<div
  [ngStyle]="{display: !showFoundSettings ? 'none' : 'flex'}"
  class="search-setting__inner"
  >
  <tui-scrollbar>
    <iv-live-columns-chooser-search-item
      *ngFor="let item of searchItems"
      [data]="item"
      [checkbox]="isSettingChecked(item.value)"
      (onCheckboxChecked)="onChecked(findNodeByText(data, item.value), $event)"
    >
    </iv-live-columns-chooser-search-item>
  </tui-scrollbar>
  <div *ngIf="!searchItems.length" class="search-setting__not-found">
    No settings found
  </div>
</div>


<ng-template
  #content
  let-item
>
  <tui-checkbox-labeled
      class="tui-space_vertical-2 tui-space_left-1"
      [ngModel]="item | tuiMapper : getValue : map"
      (ngModelChange)="onChecked(item, $event)"
      ngDefaultControl
  >
      {{ item.text }}
  </tui-checkbox-labeled>
</ng-template>
